var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenzopdiazepinesAntagonists(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.8 23.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-3{fill:#f47920;stroke:#f47920;}.cls-4{fill:url(#PatternDrugClassWhite);stroke:url(#PatternDrugClassWhite);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "PatternDrugClassWhite",
    "data-name": "PatternDrugClassWhite",
    width: 6,
    height: 6,
    patternTransform: "translate(-0.1 -0.46)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 6 6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.61,
    y1: 4.61,
    x2: 25.39,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -1.39,
    y1: 4.61,
    x2: 19.39,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -7.39,
    y1: 4.61,
    x2: 13.39,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -13.39,
    y1: 4.61,
    x2: 7.39,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -19.39,
    y1: 4.61,
    x2: 1.39,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.61,
    y1: -1.39,
    x2: 25.39,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -1.39,
    y1: -1.39,
    x2: 19.39,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -7.39,
    y1: -1.39,
    x2: 13.39,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -13.39,
    y1: -1.39,
    x2: 7.39,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -19.39,
    y1: -1.39,
    x2: 1.39,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.61,
    y1: -7.39,
    x2: 25.39,
    y2: 13.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -1.39,
    y1: -7.39,
    x2: 19.39,
    y2: 13.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -7.39,
    y1: -7.39,
    x2: 13.39,
    y2: 13.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -13.39,
    y1: -7.39,
    x2: 7.39,
    y2: 13.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -19.39,
    y1: -7.39,
    x2: 1.39,
    y2: 13.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.61,
    y1: -13.39,
    x2: 25.39,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -1.39,
    y1: -13.39,
    x2: 19.39,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -7.39,
    y1: -13.39,
    x2: 13.39,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -13.39,
    y1: -13.39,
    x2: 7.39,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -19.39,
    y1: -13.39,
    x2: 1.39,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.61,
    y1: -19.39,
    x2: 25.39,
    y2: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -1.39,
    y1: -19.39,
    x2: 19.39,
    y2: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -7.39,
    y1: -19.39,
    x2: 13.39,
    y2: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -13.39,
    y1: -19.39,
    x2: 7.39,
    y2: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -19.39,
    y1: -19.39,
    x2: 1.39,
    y2: 1.39
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 22.8,
    height: 22.08,
    rx: 5,
    transform: "translate(23.8 23.08) rotate(180)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.5.5H18.3a5,5,0,0,1,5,5V17.58a5,5,0,0,1-5,5H5.5a5,5,0,0,1-5-5V5.5A5,5,0,0,1,5.5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenzopdiazepinesAntagonists);
export default __webpack_public_path__ + "static/media/benzopdiazepines_antagonists.315d66a651fb0e0dedc4df22cc56a52a.svg";
export { ForwardRef as ReactComponent };